<template>

    <v-chip
        class="person-label"
        small
        label
    >
        <div
            class="if-more-tooltip-chip text-none"
            v-tooltip="{ content: toolTipText }"
        >
        {{ email_object.Email }}
        </div>    
        <div class="pl-actions-wrapper">
            <span
                v-tooltip.top="$t('Переотправить')"
                @click.stop="ReSend"
            >
                <i class="fas fa-paper-plane dark-gray-color"></i>
            </span>
        </div>
    </v-chip>

</template>

<script>

export default {
    name: "EMailChip",
    props: {
        email_object: {
            type: Object,
            default: null
        }
    },
    computed: {
        toolTipText () {
            return `Отправил: ${this.email_object.SenderName} ${this.$moment(this.email_object.SendDate).format('DD.MM.YYYY HH:mm:ss')}`;
        }
    },
    methods:{
        async ReSend(){
            await this.$store.dispatch(`global/actionsource/SendDocumentByEmail`, {email: this.email_object.Email});
        }   
    }
}
</script>